import { ConfirmDialog } from "@/components/ui/confirm-dialog";
import { Icon } from "@/components/ui/Icon";

interface LogoutConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const LogoutConfirmDialog = ({
  open,
  onOpenChange,
  onConfirm,
  isLoading = false,
}: LogoutConfirmDialogProps) => (
  <ConfirmDialog
    open={open}
    onOpenChange={onOpenChange}
    title="Подтвердите действие"
    description="Выход из аккаунта"
    isLoading={isLoading}
    cancelButton={{
      variant: "secondary",
      className: "order-2",
      onClick: () => onOpenChange(false),
      children: (
        <>
          <Icon name="cancel-circle" className="size-5" />
          Отмена
        </>
      ),
    }}
    confirmButton={{
      variant: "destructive",
      className: "order-1",
      onClick: onConfirm,
      children: (
        <>
          <Icon name="check-circle" className="size-5" />
          Выйти
        </>
      ),
    }}
  />
);